import React from 'react'
import { DatePicker } from 'antd'
import moment from 'moment/moment'
import WithLabel from '@components/ui/WithLabel/WithLabel'
import {
  IconAngleLeft,
  IconAngleRight,
  IconAnglesLeft,
  IconAnglesRight,
  IconCalendar,
} from '@utils/icons'

interface Props {
  onChange?: (val: [string, string]) => void
  title?: string
  value?: string
}

const WeekSelect: React.FC<Props> = ({ onChange, title, value }) => {
  const disabledDate = (current) => {
    return current && current > moment().add(1, 'weeks').startOf('isoWeek')
  }

  const handler = (e: moment.Moment) => {
    if (onChange) {
      onChange([
        e.startOf('week').format('YYYY-MM-DDTHH:mm:ss[Z]'),
        e.endOf('week').format('YYYY-MM-DDTHH:mm:ss[Z]'),
      ])
    }
  }

  const renderSelect = () => (
    <DatePicker
      onChange={(date) => handler(date)}
      picker='week'
      value={moment(value)}
      allowClear={false}
      disabledDate={disabledDate}
      suffixIcon={<IconCalendar width='1rem' height='1rem' fill='var(--color-arrows-date)' />}
      nextIcon={<IconAngleRight width='18' height='18' fill='var(--color-arrows-date)' />}
      prevIcon={<IconAngleLeft width='18' height='18' fill='var(--color-arrows-date)' />}
      superNextIcon={<IconAnglesRight width='18' height='18' fill='var(--color-arrows-date)' />}
      superPrevIcon={<IconAnglesLeft width='18' height='18' fill='var(--color-arrows-date)' />}
      style={{
        width: '100%',
      }}
      getPopupContainer={() => document.getElementById('App') || document.body}
    />
  )

  return (
    <>{title ? <WithLabel label={title}>{renderSelect()}</WithLabel> : <>{renderSelect()}</>}</>
  )
}

export default WeekSelect
